import { configureStore } from '@reduxjs/toolkit';
import superAdminReducer from './slices/superAdminSlice';
import locationReducer from './slices/locationSlice';
import centerReducer from './slices/centersSlice';
import adminReducer from './slices/adminSlice';
import employeeReducer from './slices/employeeSlice';
import callCollectionsReducer from './slices/callCollectionSlice'; // <-- Add this import
import appReleaseReducer from './slices/appReleaseSlice';
import employeeProfileReducer from './slices/employeeProfileSlice';
import { setStore } from './storeUtils';

export const store = configureStore({
  reducer: {
    superAdmin: superAdminReducer,
    location: locationReducer,
    centers: centerReducer,
    admin: adminReducer,
    employee: employeeReducer,
    callCollections: callCollectionsReducer, // <-- Add this line
    appRelease: appReleaseReducer,
    employeeProfile: employeeProfileReducer
  },
});

// Initialize the store in storeUtils
setStore(store);

export default store;